var React = require('react');

function IconPenCircleO (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M304.9 636.4v86.5h86.5l255.1-255.1-86.5-86.5-255.1 255.1zm408.4-235.5c9-9 9-23.5 0-32.5l-54-54c-9-9-23.5-9-32.5 0l-42.2 42.2 86.5 86.5 42.2-42.2z","key":0}),React.createElement("path",{"d":"M512.5 67.3c-247.4 0-448 200.5-448 448s200.5 448 448 448 448-200.5 448-448c0-247.3-200.6-448-448-448zm0 831.5C300.7 898.8 129 727.1 129 515.3s171.7-383.5 383.5-383.5S896 303.5 896 515.3c0 211.9-171.7 383.5-383.5 383.5z","key":1})]);
}

IconPenCircleO.displayName = "IconPenCircleO";

IconPenCircleO.defaultProps = {"viewBox":"0 0 1024 1024"};

module.exports = IconPenCircleO;

IconPenCircleO.default = IconPenCircleO;
